module.exports = __webpack_public_path__ + "img/therapist-main-1.8229eacf.jpg";